import React from 'react';

const HeroResults = ({ meeting }) => (
  <div className='max-w-screen-xl mt-24 px-8 xl:px-16 mx-auto'>
    <div className='grid grid-flow-row sm:grid-flow-col grid-rows-2 md:grid-rows-1 sm:grid-cols-2 gap-8 py-6 sm:py-16'>
      <div className=' flex flex-col justify-center items-start row-start-2 sm:row-start-1'>
        <h6 className='text-xl lg:text-xl xl:text-xl font-medium text-black-600 leading-normal mb-8'>
          <strong>{meeting.meeting.topic}</strong>.
        </h6>
      </div>
      <div className='flex w-full'>
        <div className='h-full w-full'>
          <h5 className='text-xl lg:text-xl xl:text-xl font-medium text-green-800 text-right'>
            Reunión ID: {meeting.meeting.id}
          </h5>
          <h5 className='text-xl lg:text-xl xl:text-xl font-medium text-green-600 text-right'>
            Grabaciones: {meeting.recordings.length}
          </h5>
        </div>
      </div>
    </div>
  </div>
);

export default HeroResults;
